<div class="period-booking">
    <!-- Debug alerts -->
    <div *ngIf="!product" class="alert alert-warning">
        <div class="alert-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
        </div>
        <div class="alert-content">
            {{ 'no_product_data' | translate }}
        </div>
    </div>
    
    <div *ngIf="product && !product.booking" class="alert alert-info">
        <div class="alert-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
        </div>
        <div class="alert-content">
            {{ 'no_booking_config' | translate }}
        </div>
    </div>
    
    <div *ngIf="product?.booking && !product.booking.forBooking" class="alert alert-info">
        <div class="alert-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
        </div>
        <div class="alert-content">
            {{ 'product_booking_disabled' | translate }} (forBooking = {{ product.booking.forBooking }})
        </div>
    </div>
    
    <div *ngIf="product?.booking?.forBooking && product?.booking?.bookingType !== 'period'" class="alert alert-info">
        <div class="alert-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
        </div>
        <div class="alert-content">
            {{ 'product_wrong_booking_type' | translate }}: "{{ product.booking.bookingType }}"
        </div>
    </div>

    <!-- Out of Stock Warning -->
    <div *ngIf="product?.booking?.forBooking && product?.booking?.bookingType === 'period' && !hasProductQuantity" class="alert alert-danger">
        <div class="alert-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
        </div>
        <div class="alert-content">
            <strong>{{ 'out_of_stock' | translate }}:</strong> {{ 'out_of_stock_desc' | translate }}
        </div>
    </div>

    <!-- Main booking content -->
    <div *ngIf="product?.booking?.forBooking && product?.booking?.bookingType === 'period' && hasProductQuantity">
        
        <!-- Booking Info Header -->
        <div class="booking-info-header" *ngIf="getConstraintsText()">
            <div class="info-content">
                <div class="info-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"/>
                        <path d="M12 6v6l4 2"/>
                    </svg>
                </div>
                <div class="info-text">{{ getConstraintsText() }}</div>
            </div>
        </div>

        <form [formGroup]="bookingForm" (ngSubmit)="createBooking()" class="booking-form">
            
            <!-- Main Content Layout: Calendar Left, Summary Right -->
            <div class="booking-layout">
                
                <!-- Left Side: Calendar -->
                <div class="calendar-section">
                    <div class="section-header">
                        <h4 class="section-title">{{ 'choose_booking_period' | translate }}</h4>
                        <div class="calendar-legend">
                            <div class="legend-item">
                                <span class="legend-dot available"></span>
                                <span class="legend-text">{{ 'available' | translate }}</span>
                            </div>
                            <div class="legend-item">
                                <span class="legend-dot selected"></span>
                                <span class="legend-text">{{ 'selected_period' | translate }}</span>
                            </div>
                            <div class="legend-item">
                                <span class="legend-dot unavailable"></span>
                                <span class="legend-text">{{ 'unavailable' | translate }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="calendar-container">
                        <!-- Loading State -->
                        <div *ngIf="loading" class="loading-state">
                            <div class="loading-spinner">
                                <div class="spinner"></div>
                            </div>
                            <span class="loading-text">{{ 'loading_available_dates' | translate }}</span>
                        </div>

                        <!-- Calendar -->
                        <div *ngIf="!loading && calendarMonths.length > 0" class="calendar">
                            <!-- Calendar Navigation -->
                            <div class="calendar-nav">
                                <button type="button" 
                                        class="nav-btn prev"
                                        [disabled]="!canGoPrevious()"
                                        (click)="goToPreviousMonth()">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <path d="M15 18l-6-6 6-6"/>
                                    </svg>
                                </button>

                                <div class="month-display">
                                    <h3 class="month-title">{{ getTranslatedMonthYear() }}</h3>
                                </div>

                                <button type="button" 
                                        class="nav-btn next"
                                        [disabled]="!canGoNext()"
                                        (click)="goToNextMonth()">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <path d="M9 18l6-6-6-6"/>
                                    </svg>
                                </button>
                            </div>

                            <!-- Calendar Grid -->
                            <div class="calendar-grid">
                                <!-- Weekday Headers -->
                                <div class="weekday-header">
                                    <div class="weekday" *ngFor="let day of getTranslatedWeekDays()">{{ day }}</div>
                                </div>

                                <!-- Calendar Days -->
                                <div class="calendar-days">
                                    <div *ngFor="let day of getCurrentMonth().days" 
                                         class="calendar-day"
                                         [class.available]="day.isAvailable && day.isCurrentMonth"
                                         [class.selected]="day.isSelected"
                                         [class.in-range]="isDateInHoverRange(day.date)"
                                         [class.range-start]="day.date === startDate"
                                         [class.range-end]="day.date === endDate"
                                         [class.unavailable]="day.isUnavailable && day.isCurrentMonth"
                                         [class.other-month]="!day.isCurrentMonth"
                                         [class.today]="day.isToday"
                                         [title]="getDateTitle(day)"
                                         (click)="onDateSelected(day)"
                                         (mouseenter)="onDateHovered(day)">
                                        
                                        <span class="day-number">{{ day.day }}</span>
                                        
                                        <!-- Today indicator -->
                                        <div *ngIf="day.isToday && !day.isSelected" class="today-dot"></div>
                                        
                                        <!-- Quantity badge for available dates -->
                                        <div *ngIf="day.isAvailable && day.isCurrentMonth && !day.isSelected && getAvailableQuantityForDate(day.date) > 0 && productQuantity > 1" 
                                             class="quantity-badge"
                                             [class.partial-quantity]="getAvailableQuantityForDate(day.date) < productQuantity"
                                             [class.full-quantity]="getAvailableQuantityForDate(day.date) === productQuantity">
                                            {{ getAvailableQuantityForDate(day.date) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- No Data State -->
                        <div *ngIf="!loading && calendarMonths.length === 0" class="no-data-state">
                            <div class="no-data-icon">📅</div>
                            <h4>{{ 'no_dates_available' | translate }}</h4>
                            <p>{{ 'no_dates_available_desc' | translate }}</p>
                        </div>
                    </div>
                </div>

                <!-- Right Side: Summary and Actions -->
                <div class="summary-section">
                    
                    <!-- Quantity Selector -->
                    <div class="quantity-section">
                        <div class="card-header">
                            <h4 class="card-title">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                                    <line x1="8" y1="21" x2="16" y2="21"/>
                                    <line x1="12" y1="17" x2="12" y2="21"/>
                                </svg>
                                {{ 'quantity' | translate }}
                            </h4>
                        </div>
                        <div class="quantity-control">
                            <app-input-number-new 
                                appClick 
                                layout="input-5" 
                                aria-label="Quantity"
                                class="product__quantity-availability amount quote-qty" 
                                [min]="product.quantity?.min || 1"
                                [max]="product.quantity?.max || 99" 
                                [step]="product.quantity?.step || 1"
                                [formControl]="quantityControl">
                            </app-input-number-new>
                        </div>
                    </div>

                    <!-- Selected Period -->
                    <div class="selected-period-card">
                        <div class="card-header">
                            <h4 class="card-title">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                                    <line x1="16" y1="2" x2="16" y2="6"/>
                                    <line x1="8" y1="2" x2="8" y2="6"/>
                                    <line x1="3" y1="10" x2="21" y2="10"/>
                                </svg>
                                {{ 'selected_period' | translate }}
                                <span class="period-counter" *ngIf="totalDays > 0">
                                    ({{ totalDays }} {{ (totalDays === 1 ? 'day' : 'days') | translate }})
                                </span>
                                <span class="quantity-indicator" *ngIf="totalDays > 0 && selectedQuantity > 1">
                                    × {{ selectedQuantity }}
                                </span>
                            </h4>
                            <!-- <button type="button" 
                                    class="clear-btn" 
                                    (click)="clearSelection()"
                                    *ngIf="startDate || endDate">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6m3 0V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                                </svg>
                                {{ 'clear_selection' | translate }}
                            </button> -->
                        </div>
                        
                        <!-- Period display -->
                        <div class="selected-period-content">
                            <div *ngIf="!startDate && !endDate" class="empty-state">
                                <div class="empty-icon">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                                        <line x1="16" y1="2" x2="16" y2="6"/>
                                        <line x1="8" y1="2" x2="8" y2="6"/>
                                        <line x1="3" y1="10" x2="21" y2="10"/>
                                    </svg>
                                </div>
                                <p class="empty-text">{{ 'select_start_end_dates' | translate }}</p>
                            </div>
                            
                            <div *ngIf="startDate && !endDate" class="selecting-state">
                                <div class="start-date">
                                    <strong>{{ 'start_date' | translate }}:</strong>
                                    <span>{{ startDate | date:'mediumDate' }}</span>
                                </div>
                                <p class="instruction">{{ 'click_end_date' | translate }}</p>
                            </div>
                            
                            <div *ngIf="startDate && endDate" class="period-selected">
                                <div class="period-info">
                                    <div class="date-range">
                                        <strong>{{ getFormattedDateRange() }}</strong>
                                    </div>
                                    <div class="period-duration">
                                        {{ totalDays }} {{ (totalDays === 1 ? 'day' : 'days') | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Price Summary -->
                    <div class="price-summary-card">
                        <div class="card-header">
                            <h4 class="card-title">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <circle cx="12" cy="12" r="10"/>
                                    <path d="M12 6v6"/>
                                    <path d="M16 10l-4 4-4-4"/>
                                </svg>
                                {{ 'booking_summary' | translate }}
                            </h4>
                        </div>
                        
                        <div class="price-details">
                            <div *ngIf="totalDays === 0" class="empty-summary">
                                <p>{{ 'select_period_to_see_pricing' | translate }}</p>
                            </div>
                            
                            <div *ngIf="totalDays > 0">
                                @if(!isQuotable){

                                    <div class="price-row">
                                        <span class="price-label">
                                            {{ 'price_per_day' | translate }}
                                        </span>
                                        <span class="price-value">{{ product?.taxedPrice || product?.price | currencyConvert : product.companyData.currencyMeta.code }}</span>
                                    </div>
                                }
                                
                                <div class="price-row">
                                    <span class="price-label">
                                        {{ 'number_of_days' | translate }}
                                    </span>
                                    <span class="price-value">{{ totalDays }}</span>
                                </div>

                                <div class="price-row" *ngIf="selectedQuantity > 1">
                                    <span class="price-label">
                                        {{ 'quantity' | translate }}
                                    </span>
                                    <span class="price-value">{{ selectedQuantity }}</span>
                                </div>

                                <div class="price-row" *ngIf="selectedQuantity > 1 && !isQuotable">
                                    <span class="price-label">
                                        {{ 'subtotal' | translate }}
                                    </span>
                                    <span class="price-value">{{ (totalDays * (product?.price || 0)) | currencyConvert : product.companyData.currencyMeta.code }}</span>
                                </div>

                                @if(!isQuotable){
                                    <div class="price-row total-row">
                                        <span class="price-label">{{ 'total_amount' | translate }}</span>
                                        <span class="price-value total-amount">{{ totalPrice | currencyConvert : product.companyData.currencyMeta.code }}</span>
                                    </div>
                                }
                                
                            </div>
                        </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="action-section">
                        <div class="action-buttons">
                            <button type="button" 
                                    class="btn btn-secondary" 
                                    (click)="clearSelection()"
                                    [disabled]="loading || (!startDate && !endDate)">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6m3 0V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                                </svg>
                                {{ 'reset_selection' | translate }}
                            </button>
                            
                            <button type="submit" 
                                    class="btn btn-primary" 
                                    [disabled]="bookingForm.invalid || !startDate || !endDate || loading">
                                <span *ngIf="loading" class="btn-spinner"></span>
                                
                                <!-- Cart icon for non-quotation products -->
                                <svg *ngIf="!loading && !isQuotable" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <circle cx="9" cy="21" r="1"/>
                                    <circle cx="20" cy="21" r="1"/>
                                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                                </svg>
                                
                                <!-- Check icon for quotation products -->
                                <svg *ngIf="!loading && isQuotable" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M9 11l3 3 8-8"/>
                                </svg>
                                
                                <!-- Button text -->
                                <span *ngIf="!loading && !isQuotable">{{ 'add_to_cart' | translate }}</span>
                                <span *ngIf="!loading && isQuotable">{{ 'review_quote_request' | translate }}</span>
                                <span *ngIf="loading && !isQuotable">{{ 'adding_to_cart' | translate }}</span>
                                <span *ngIf="loading && isQuotable">{{ 'requesting_quote' | translate }}</span>
                            </button>

                            <!-- Buy Now button: visible only for non-quotation booking products -->
                            <button type="button"
                                    class="btn btn-primary"
                                    *ngIf="!isQuotable"
                                    [disabled]="loading || !startDate || !endDate"
                                    (click)="buyNow()">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M3 3h18v4H3z"></path>
                                    <path d="M6 14l3 3 9-9"></path>
                                </svg>
                                {{ 'buyNow' | translate }}
                            </button>
                        </div>
                    </div>

                    <!-- Additional Info -->
                    <div class="additional-info" *ngIf="product?.booking?.requireApproval && !isQuotable">
                        <div class="info-card">
                            <div class="info-icon">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <circle cx="12" cy="12" r="10"/>
                                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                                    <path d="M12 17h.01"/>
                                </svg>
                            </div>
                            <div class="info-content">
                                <strong>{{ 'requires_approval' | translate }}:</strong> {{ 'approval_required_desc' | translate }}
                            </div>
                        </div>
                    </div>


                    <!-- Validation Errors -->
                    <div class="validation-error" *ngIf="bookingForm.get('startDate')?.errors?.['required'] || bookingForm.get('endDate')?.errors?.['required']">
                        <div class="error-card">
                            <div class="error-icon">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <circle cx="12" cy="12" r="10"/>
                                    <path d="M15 9l-6 6M9 9l6 6"/>
                                </svg>
                            </div>
                            <div class="error-content">
                                <strong>{{ 'selection_error' | translate }}:</strong> {{ 'period_dates_required' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

<!-- Quotation Request Modal -->
<div *ngIf="showQuotationForm" class="quotation-modal-overlay" (click)="closeQuotationForm()">
    <div class="quotation-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3 class="modal-title">{{ 'request_quote' | translate }}</h3>
            <button type="button" class="modal-close" (click)="closeQuotationForm()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"/>
                    <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <!-- Booking Summary -->
            <div class="booking-summary">
                <h4>{{ 'booking_summary' | translate }}</h4>
                <div class="summary-grid">
                    <div class="summary-row">
                        <span class="label">{{ 'product' | translate }}:</span>
                        <span class="value">{{ (product.name.en | translate) || product.name.en }}</span>
                    </div>
                    <div class="summary-row">
                        <span class="label">{{ 'period' | translate }}:</span>
                        <span class="value">{{ getFormattedDateRange() }}</span>
                    </div>
                    <div class="summary-row">
                        <span class="label">{{ 'total_days' | translate }}:</span>
                        <span class="value">{{ totalDays }} {{ 'days' | translate }}</span>
                    </div>
                    <div class="summary-row">
                        <span class="label">{{ 'quantity' | translate }}:</span>
                        <span class="value">{{ selectedQuantity }}</span>
                    </div>
                    <div class="summary-row">
                        <span class="label">{{ 'total_period_items' | translate }}:</span>
                        <span class="value">{{ totalDays * selectedQuantity }}</span>
                    </div>
                </div>
            </div>

            <!-- Quote Request Form -->
            <div class="quote-form">
                <form [formGroup]="quotationForm" (ngSubmit)="submitQuotationRequest()">
                    <div class="form-field">
                        <label>{{ 'additional_requirements' | translate }}</label>
                        <textarea 
                            formControlName="description"
                            rows="4"
                            [placeholder]="'describe_special_requests' | translate"></textarea>
                    </div>

                    <div class="form-actions">
                        <button type="button" class="btn-cancel" (click)="closeQuotationForm()">
                            {{ 'cancel' | translate }}
                        </button>
                        <button type="submit" class="btn-submit" [disabled]="loading">
                            <span *ngIf="loading" class="spinner"></span>
                            {{ 'send_request' | translate }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
